import Immutable from 'immutable';
import * as types from './MyUthealthEditor.types';

const initialState = {
    templateCode: null,
    variables: {
        quantity: '',
        language: 'English',
        clinic_id: '',
        location_id: '',
        clinic_name: '',
        your_location: '',
        other_location: 0,
    },
    item: null,
    fetching: false,
    addingToCart: false,
    clinics: [],
    fetchingClinics: false,
    locations: [],
    fetchingLocations: false,
    isFavorite: false,
    addingFavorite: false,
    checkingFavorite: false,
    savingWork: false,
    action: null,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_ITEM:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_ITEM_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['item'], action.payload)
                .toJS();

        case types.FETCH_ITEM_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.FETCH_CLINICS:
            return state.setIn(['fetchingClinics'], true).toJS();

        case types.FETCH_CLINICS_SUCCESS:
            return state.setIn(['fetchingClinics'], false)
                .setIn(['clinics'], action.payload)
                .toJS();

        case types.FETCH_CLINICS_ERROR:
            return state.setIn(['fetchingClinics'], false).toJS();

        case types.FETCH_LOCATIONS:
            return state.setIn(['fetchingLocations'], true).toJS();

        case types.FETCH_LOCATIONS_SUCCESS:
            return state.setIn(['fetchingLocations'], false)
                .setIn(['locations'], action.payload)
                .setIn(['variables', 'location_id'], action.payload.length > 0 ? action.payload[0].id : '')
                .toJS();

        case types.FETCH_LOCATIONS_ERROR:
            return state.setIn(['fetchingLocations'], false).toJS();

        case types.ADD_TO_CART:
            if (parseInt(action.payload) === 2) {
                return state.setIn(['savingWork'], true).toJS();
            }
            return state.setIn(['addingToCart'], true).toJS();

        case types.ADD_TO_CART_SUCCESS:
            return state.setIn(['addingToCart'], false)
                .setIn(['savingWork'], false)
                .toJS();

        case types.ADD_TO_CART_ERROR:
            return state.setIn(['addingToCart'], false)
                .setIn(['savingWork'], false)
                .toJS();

        case types.SET_TEMPLATE_CODE:
            return state.setIn(['templateCode'], action.payload).toJS();

        case types.SET_QUANTITY:
            return state.setIn(['variables', 'quantity'], action.payload).toJS();

        case types.SET_NOTES:
            return state.setIn(['variables', 'notes'], action.payload).toJS();

        case types.SET_LANGUAGE:
            return state.setIn(['variables', 'language'], action.payload).toJS();

        case types.SET_PRODUCT:
            return state.setIn(['variables', 'product'], action.payload).toJS();

        case types.SET_CLINIC_ID:
            return state.setIn(['variables', 'clinic_id'], action.payload).toJS();

        case types.SET_LOCATION_ID:
            return state.setIn(['variables', 'location_id'], action.payload).toJS();

        case types.SET_OTHER_LOCATION:
            return state.setIn(['variables', 'other_location'], action.payload).toJS();

        case types.SET_CLINIC_NAME:
            return state.setIn(['variables', 'clinic_name'], action.payload).toJS();

        case types.SET_YOUR_LOCATION:
            return state.setIn(['variables', 'your_location'], action.payload).toJS();

        case types.ADD_FAVORITE:
            return state.setIn(['addingFavorite'], true).toJS();

        case types.ADD_FAVORITE_SUCCESS:
            return state.setIn(['addingFavorite'], false)
                .setIn(['isFavorite'], parseInt(action.payload.type) === 1)
                .toJS();

        case types.ADD_FAVORITE_ERROR:
            return state.setIn(['addingFavorite'], false).toJS();

        case types.CHECK_FAVORITE:
            return state.setIn(['checkingFavorite'], true).toJS();

        case types.CHECK_FAVORITE_SUCCESS:
            return state.setIn(['checkingFavorite'], false)
                .setIn(['isFavorite'], parseInt(action.payload.favorite) === 1)
                .toJS();

        case types.CHECK_FAVORITE_ERROR:
            return state.setIn(['checkingFavorite'], false).toJS();

        case types.SET_ACTION:
            return state.setIn(['action'], action.payload).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}